import { put, takeLatest } from "redux-saga/effects";
import { requestPropertyOwnerList 
    ,requestCreatePropertyOwner, requestUpdatePropertyOwner
} from "services/property-owner";

import {
  fetchPropertyOwner,
  fetchPropertyOwnerSuccess,
  fetchPropertyOwnerFailure,

  createPropertyOwner,
  createPropertyOwnerSuccess,
  createPropertyOwnerFailure,
  updatePropertyOwner,
  updatePropertyOwnerSuccess,
  updatePropertyOwnerFailure
} from "../../actions/property-owner/property-owner";

import {
    FETCH_PROPERTY_OWNER_REQUEST,
    FETCH_PROPERTY_OWNER_SUCCESS,
    FETCH_PROPERTY_OWNER_FAILURE,
    CREATE_PROPERTY_OWNER_REQUEST,
  UPDATE_PROPERTY_OWNER_REQUEST
} from "../../actions/property-owner/types";

export function* watchPropertyOwnerSaga() {
  yield takeLatest(FETCH_PROPERTY_OWNER_REQUEST, fetchPropertyOwnerList);
  yield takeLatest(CREATE_PROPERTY_OWNER_REQUEST, createPropertyOwnerRequest);
  yield takeLatest(UPDATE_PROPERTY_OWNER_REQUEST, updatePropertyOwnerRequest);
}

function* fetchPropertyOwnerList({ payload }) {
  try {
    /**
     * @type {FetchBrokerFirmsResponse}
     */
    const response = yield requestPropertyOwnerList(payload);
    yield put(fetchPropertyOwnerSuccess(response));
  } catch (error) {
    yield put(fetchPropertyOwnerFailure("Failed to get list of Property Owner list"));
  }
}



/**
 *
 * @param {PARAMS} param0
 */
 function* createPropertyOwnerRequest({ payload }) {
  try {
      const response = yield requestCreatePropertyOwner(payload);
      yield put(createPropertyOwnerSuccess(response.data));
  } catch (error) {
      yield put(
        createPropertyOwnerFailure('Failed to create Property Owner')
      );
  }
}

/**
*
* @typedef {Object} BrokerFirmUpdatePayload
* @property {BrokerFirm} payload
*
* @param {BrokerFirmUpdatePayload} param0
*/
function* updatePropertyOwnerRequest({ payload }) {
  try {
     const response = yield requestUpdatePropertyOwner(payload);
      yield put(updatePropertyOwnerSuccess(response.data));
  } catch (error) {
      yield put(
        updatePropertyOwnerFailure('Failed to update Property Owner')
      );
  }
}